export const itData = `
  <div class="paragraph">
    <div class="title">Cosa devo fare prima di inviare il mio telefono?</div>
    <div class="text-box">
      <div class="text">
        Prima di spedire il tuo dispositivo, assicurati di:
      </div>
      <div class="text">
      - Cancellare tutti i dati personali e rimuovere eventuali PIN, password o pattern di sblocco
      </div>
      <div class="text">
      - Eseguire un ripristino completo alle impostazioni di fabbrica
      </div>
      <div class="text">
      - Per iPhone: disconnettere l’account iCloud disattivando “Trova il mio iPhone”
      </div>
      <div class="text">
      - Per dispositivi Android: rimuovere l’account Google (Impostazioni > Account > Google > Rimuovi account)
      </div>
      <div class="text">
      Questi passaggi garantiscono che il dispositivo non sia più collegato al tuo account personale, evitando problemi di blocco durante la valutazione. Inoltre, proteggono le tue informazioni e permettono al nostro team di ispezione di processare il dispositivo senza intoppi.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Posso inviare un telefono con blocco SIM?</div>
    <div class="text-box">
      <div class="text">
        No, non accettiamo dispositivi bloccati da un operatore specifico (dispositivi con blocco SIM).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Devo includere accessori come caricabatterie o cavo?</div>
    <div class="text-box">
      <div class="text">
        Non è obbligatorio, ma è consigliato. Includere gli accessori aiuta a promuovere la sostenibilità attraverso il riutilizzo e il corretto riciclo.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Devo inviare anche le cuffie?</div>
    <div class="text-box">
      <div class="text">
        No. Per motivi igienici, le cuffie non saranno incluse nella valutazione e verranno smaltite.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Devo inviare la fattura di acquisto?</div>
    <div class="text-box">
      <div class="text">
        No. La fattura non è necessaria per la valutazione né per il pagamento. Puoi conservarla per i tuoi archivi personali.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Come viene valutato il mio telefono?</div>
    <div class="text-box">
      <div class="text">
        Una volta ricevuto il dispositivo nel nostro centro di ispezione, utilizziamo software diagnostici e controlli manuali per valutarne le condizioni.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa succede se la condizione da me dichiarata non corrisponde alla vostra valutazione?</div>
    <div class="text-box">
      <div class="text">
      In caso di discrepanza, ti invieremo un’offerta aggiornata via email. Se il nuovo importo è pari o inferiore di massimo 13 € rispetto alla tua valutazione iniziale, procederemo automaticamente. Se la differenza è maggiore, avrai 5 giorni lavorativi per accettare o rifiutare la nuova offerta.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa succede se rifiuto l’offerta aggiornata?</div>
    <div class="text-box">
      <div class="text">
         Il dispositivo ti verrà restituito gratuitamente. La procedura di reso inizierà entro 5 giorni lavorativi dalla conferma del tuo rifiuto.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa succede se non rispondo all’offerta aggiornata?</div>
    <div class="text-box">
      <div class="text">
      Se non riceviamo una risposta entro 5 giorni lavorativi, l’offerta aggiornata verrà accettata automaticamente e il processo continuerà.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa succede ai miei dati personali?</div>
    <div class="text-box">
      <div class="text">
      Ti invitiamo a cancellare tutti i dati personali prima di spedire il dispositivo. Se rileviamo dati residui, sospenderemo l’elaborazione e ti contatteremo per ottenere l’autorizzazione alla cancellazione. Rispettiamo il Regolamento Generale sulla Protezione dei Dati (GDPR - Regolamento UE 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Chi copre i costi di spedizione?</div>
    <div class="text-box">
      <div class="text">
      La spedizione iniziale (verso il nostro centro) è gratuita. Se rifiuti la nostra offerta aggiornata, copriremo anche il costo del reso.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa succede se il pacco viene perso durante la spedizione?</div>
    <div class="text-box">
      <div class="text">
      Danghuan non è responsabile per eventuali smarrimenti durante la spedizione, anche se viene utilizzata l’etichetta fornita da noi.
      </div>
      <div class="text">
      Tuttavia, in caso di pacco smarrito, saremo lieti di assisterti nella richiesta di risarcimento al corriere. Per farlo:
      </div>
      <div class="text">
      - Assicurati di aver usato l’etichetta ufficiale e di conservare la ricevuta della spedizione
      </div>
      <div class="text">
      - Contatta il nostro Servizio Clienti all’indirizzo support@danghuan.eu
      </div>
      <div class="text">
      - Le richieste per pacchi smarriti possono essere avviate a partire da 15 giorni di calendario dalla data di spedizione
      </div>
      <div class="text">
      Nota: Eventuali risarcimenti dipendono dalla politica del corriere e non da Danghuan.
      </div>
    </div>
  </div>

  <div class="paragraph">
    <div class="title">Quando riceverò il pagamento?</div>
    <div class="text-box">
      <div class="text">
      Dopo l’accettazione dell’offerta finale, il pagamento verrà effettuato tramite bonifico bancario entro 3 giorni lavorativi. Assicurati che l’IBAN o i dati di pagamento siano corretti.
      </div>
    </div>
  </div>

  <div class="paragraph">
    <div class="title">Posso annullare la mia permuta?</div>
    <div class="text-box">
      <div class="text">
      Sì, ma solo se il pagamento per il dispositivo non è ancora stato effettuato. Per annullare, contattaci il prima possibile all’indirizzo support@danghuan.eu.
      </div>
    </div>
  </div>

  <div class="paragraph">
    <div class="title">Come posso annullare un ordine di permuta già confermato?</div>
    <div class="text-box">
      <div class="text">
      Se hai già ricevuto l’email di conferma ma desideri annullare l’ordine, scrivici a support@danghuan.eu indicando il numero dell’ordine. Ti assisteremo nella procedura.
      </div>
    </div>
  </div>
`;
